/*eslint-disable*/
import React from 'react';
import { Button } from 'semantic-ui-react';
import ReactFileReader from 'react-file-reader';
import cogoToast from 'cogo-toast';
import { INVALID_FILE_FORMAT } from '../../utils/validationConstant';

const UploadFile = ({
    field: { name, value },
    form: { touched, errors, setFieldValue },
    ...props
}) => {

    return (
        <>
            <ReactFileReader base64={true} fileTypes={props.typer}
                handleFiles={(value) => {if( value.fileList[0].type == ('application/pdf') || value.fileList[0].type == ('image/jpeg') ||value.fileList[0].type ==  ('image/png')){setFieldValue(name, value) ; props.onChangeExtra && props.onChangeExtra (value)}else{cogoToast.error(INVALID_FILE_FORMAT)}}}
                {...props}
            >
                <Button color={props.clrd} basic type="button" size="tiny" icon>
                    <i className="fas fa-upload"></i> {props.buttonName}
                </Button>
            </ReactFileReader>
            {/* <Input
                transparent
                size="mini"
                type="file"
                onChange={(value) => setFieldValue(name, value.currentTarget.files[0])}
                {...props}
            />
            <small className="w3-text-red p-bold-600">{touched[name] && errors[name]}</small> */}
        </>
    )
}

export default UploadFile